var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({"display": (_vm.isStandby? "block" : "none" )}),attrs:{"id":"standby"}},[_c('div',{attrs:{"id":"standbybg"}}),_vm._v(" "),_c('div',{attrs:{"id":"standbytext"}},[_c('p',[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.subline))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593df42b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Standby.vue
// module id = 65
// module chunks = 0